import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Tag } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { api } from "@/lib/api";
import { INSIGHT_POSTS, InsightPost } from "@/lib/content";

type Post = InsightPost & { cover_url?: string };

export default function Blog({ onOpenPalette }: { onOpenPalette: () => void }) {
  const [posts, setPosts] = useState<Post[]>(INSIGHT_POSTS);
  useEffect(() => {
    api.get("/blog")
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length) {
          setPosts(response.data);
        }
      })
      .catch(() => setPosts(INSIGHT_POSTS));
  }, []);

  return (
    <>
      <Navbar onOpenPalette={onOpenPalette} />
      <main className="pt-28 pb-12 page-fade" data-testid="blog-page">
        <div className="container-edx pt-16 max-w-5xl">
          <div className="section-index">EDX.01</div>
          <h1 className="display mt-4 text-4xl md:text-6xl text-white">EDENOX <span className="gradient-text">Insights</span></h1>
          <p className="mt-4 text-edx-muted">Articles, case studies, and thoughts on shipping world-class software in South Africa.</p>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p, i) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`post-${i}`}
                className="glass glass-edge tilt p-6 flex flex-col group">
                <div className="h-32 -m-6 mb-4 rounded-t-[18px] bg-gradient-to-br from-edx-blue via-edx-purple to-edx-pink relative overflow-hidden">
                  <div className="absolute inset-0 edx-noise" />
                  <div className="absolute bottom-3 right-3 text-[10px] font-mono uppercase tracking-widest text-white/80">
                    {new Date(p.created_at).toLocaleDateString("en-ZA", { month: "short", day: "numeric", year: "numeric" })}
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {p.tags?.slice(0, 3).map((t) => (
                    <span key={t} className="text-[9px] font-mono uppercase tracking-widest text-edx-cyan px-2 py-0.5 rounded-full border border-edx-cyan/30 bg-edx-cyan/5">{t}</span>
                  ))}
                </div>
                <h3 className="display font-bold text-lg text-white group-hover:text-edx-cyan transition-colors">{p.title}</h3>
                <p className="mt-2 text-sm text-edx-muted line-clamp-3 flex-1">{p.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs">
                  <span className="text-edx-muted font-mono">— {p.author}</span>
                  <span className="text-edx-cyan flex items-center gap-1">Read <ArrowRight size={12} /></span>
                </div>
              </Link>
            ))}
            {posts.length === 0 && (
              <div className="md:col-span-3 text-center text-edx-muted py-16">Loading insights…</div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
